import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { Suspense, useEffect, useState } from 'react';
import { Placeholder } from 'semantic-ui-react';
import _isString from 'lodash/isString';
import { EAGER_LOAD_STRATEGY, IN_VIEWPORT_LOAD_STRATEGY, LAZY_BROWSER_LOAD_STRATEGY, LAZY_AFTER_USER_INTERACTION_LOAD_STRATEGY } from './Embed.constants';
import { EmbedLoadStrategyPropType } from './Embed.types';
import { ChildrenPropType } from '../../../../services/proptypes';
import { classNames } from '../../../../utils/classname';
import { isServerSideRendering } from '../../../../utils/gatsby';
import useIntersectionObserver from '../../hooks/use-intersection-observer/use-intersection-observer';
import useUserInteraction from '../../hooks/use-user-interaction/use-user-interaction';
import Icon from '../Icon/Icon';
import './Embed.less';
var LazyEmbed = /*#__PURE__*/React.lazy(function () {
  return import('semantic-ui-react/dist/commonjs/modules/Embed');
});
var defaultProps = {
  fallback: /*#__PURE__*/React.createElement(Placeholder, {
    className: "placeholder embed"
  }, /*#__PURE__*/React.createElement(Placeholder.Image, null)),
  className: '',
  icon: /*#__PURE__*/React.createElement(Icon, {
    iconName: "video play"
  }),
  loadStrategy: LAZY_AFTER_USER_INTERACTION_LOAD_STRATEGY
};
export default function Embed(_ref) {
  var _classNames;
  var url = _ref.url,
    fallback = _ref.fallback,
    className = _ref.className,
    loadStrategy = _ref.loadStrategy,
    icon = _ref.icon;
  var isEager = loadStrategy === EAGER_LOAD_STRATEGY;
  var isLazyBrowser = loadStrategy === LAZY_BROWSER_LOAD_STRATEGY;
  var isInViewport = loadStrategy === IN_VIEWPORT_LOAD_STRATEGY;
  var isLazyAfterUserInteraction = loadStrategy === LAZY_AFTER_USER_INTERACTION_LOAD_STRATEGY;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    iFrameRef = _useState2[0],
    setIframeRef = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loaded = _useState4[0],
    setLoaded = _useState4[1];
  var _useIntersectionObser = useIntersectionObserver(iFrameRef, {
      defaultActive: isInViewport
    }),
    inViewport = _useIntersectionObser.inViewport,
    disconnect = _useIntersectionObser.disconnect;
  var _useUserInteraction = useUserInteraction(),
    anyInteraction = _useUserInteraction.anyInteraction;
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    enteredViewPort = _useState6[0],
    setEnteredViewPort = _useState6[1];
  useEffect(function () {
    if (inViewport) {
      setEnteredViewPort(true);
      disconnect();
    }
  }, [inViewport]);
  function getActive() {
    if (isEager || isLazyBrowser) {
      return true;
    }
    if (isInViewport) {
      return enteredViewPort;
    }
    if (isLazyAfterUserInteraction) {
      return anyInteraction;
    }
    return true;
  }
  function getLoading() {
    if (isEager) {
      return 'eager';
    }
    return 'lazy';
  }
  function setIFrameAsLoaded() {
    setLoaded(true);
  }
  var finalClassName = classNames((_classNames = {
    embed: true,
    'fisherman-embed': true
  }, _defineProperty(_classNames, className, className), _defineProperty(_classNames, "loaded", loaded), _classNames));
  if (isServerSideRendering()) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: fallback
  }, /*#__PURE__*/React.createElement(LazyEmbed, {
    url: url,
    active: getActive(),
    className: finalClassName,
    iframe: {
      loading: getLoading(),
      onLoad: setIFrameAsLoaded
    },
    icon: /*#__PURE__*/React.createElement("div", {
      className: "icon-container",
      ref: setIframeRef
    }, _isString(icon) ? /*#__PURE__*/React.createElement(Icon, {
      className: icon
    }) : icon)
  }));
}
Embed.defaultProps = defaultProps;